import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ko from './locales/ko.json';
import zh from './locales/zh.json';
import ru from './locales/ru.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import id from './locales/id.json';
import pt from './locales/pt.json';
import vi from './locales/vi.json';
import de from './locales/de.json';
import tr from './locales/tr.json';
import uk from './locales/uk.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ko: { translation: ko },
      zh: { translation: zh },
      ru: { translation: ru },
      es: { translation: es },
      fr: { translation: fr },
      id: { translation: id },
      pt: { translation: pt },
      vi: { translation: vi },
      de: { translation: de },
      tr: { translation: tr },
      uk: { translation: uk },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
